import { createEntityAdapter, EntityState } from '@ngrx/entity'
import { Action, createReducer, on } from '@ngrx/store'
import { lensPath, set, view, __ } from 'ramda'
import { ApplicationError } from '../../error/model/error'
import { parseClientsFromEntitiesResponse } from '../model/client.converter'
import { Client } from '../model/client.model'
import * as AuthActions from './auth/auth.actions'

interface ExtendedState {
  loading: boolean
  error: ApplicationError | null
}
export type State = EntityState<Client> & ExtendedState

export const adapter = createEntityAdapter<Client>()

const initialState: State = adapter.getInitialState<ExtendedState>({
  loading: false,
  error: null,
})

const clientsReducer = createReducer(
  initialState,

  on(AuthActions.identifySuccess, (state) => ({
    ...state,
    loading: initialState.loading,
    error: initialState.error,
  })),

  on(AuthActions.identifyPermissionsFailure, (state, { error }) => ({
    ...state,
    loading: initialState.loading,
    error,
  })),

  on(AuthActions.identifyPermissionsSuccess, (state, action) => {
    const clients = parseClientsFromEntitiesResponse(action)
    const next = adapter.setAll(clients, state)
    return {
      ...next,
      loading: initialState.loading,
      error: initialState.error,
    }
  }),
)

export function reducer(state: State | undefined, action: Action) {
  return clientsReducer(state, action)
}
